<template>
  <div class="coulomb-vector-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_total = Σ k (q₁q₂ / r²) r̂$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Static Charges -->
          <g v-for="(q, i) in fixedCharges" :key="i">
             <circle :cx="q.x" :cy="q.y" r="12" :fill="q.val > 0 ? '#ff4757' : '#2ed573'" />
             <text :x="q.x - 5" :y="q.y + 4" fill="#fff" font-size="10">{{ q.val > 0 ? '+' : '-' }}</text>
             <text :x="q.x - 10" :y="q.y + 25" fill="#888" font-size="8">Q{{ i+1 }}</text>
          </g>

          <!-- Test Charge (Draggable/Movable) -->
          <circle :cx="testQ.x" :cy="testQ.y" r="8" fill="#ffd700" stroke="#fff" stroke-width="1" />
          <text :x="testQ.x - 4" :y="testQ.y + 4" fill="#000" font-size="8">+</text>

          <!-- Net Force Vector -->
          <line :x1="testQ.x" :y1="testQ.y" :x2="testQ.x + netForce.x" :y2="testQ.y + netForce.y" stroke="#ffd700" stroke-width="3" marker-end="url(#f-arrow)" />
          
          <defs>
            <marker id="f-arrow" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
              <polygon points="0 0, 10 3.5, 0 7" fill="#ffd700" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>合力方向遵循矢量合成定则</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>移动测试电荷位置</label>
             <el-slider v-model="testQ.x" :min="50" :max="350" size="mini"></el-slider>
          </div>
          <div class="row">
             <el-button size="mini" @click="randomizeCharges">随机分布电荷</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>任意点电荷受到的电场力等于其他电荷单独存在时对其作用力的**矢量和**。库仑力的大小与距离的平方成反比。通过该实验可以直观观察到多电荷系统中，合力方向随空间位置的剧烈变化。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoulombForceVectorViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      fixedCharges: [
        { x: 100, y: 80, val: 1 },
        { x: 300, y: 160, val: -1 }
      ],
      testQ: { x: 200, y: 120 }
    }
  },
  computed: {
    netForce() {
      let fx = 0, fy = 0;
      this.fixedCharges.forEach(q => {
        let dx = this.testQ.x - q.x;
        let dy = this.testQ.y - q.y;
        let r2 = dx*dx + dy*dy;
        if (r2 < 400) r2 = 400; // Prevent infinity
        let r = Math.sqrt(r2);
        let f = (10000 * q.val) / r2; // Scale factor
        fx += f * (dx / r);
        fy += f * (dy / r);
      });
      return { x: fx, y: fy };
    }
  },
  methods: {
    randomizeCharges() {
       this.fixedCharges.forEach(q => {
          q.x = 50 + Math.random() * 300;
          q.y = 50 + Math.random() * 140;
          q.val = Math.random() > 0.5 ? 1 : -1;
       });
    }
  }
}
</script>

<style scoped lang="scss">
.coulomb-vector-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
